export default function FormsRoute() {
	return <p>Forms</p>
}
